import { useEffect, useState } from "react";
import ReviewItem from "../../components/review/Review.item";
import { Container } from "./styles";
import { ReviewApi } from "../../api/Review.api";
import Review from "../../models/Review.model";
import { useSearchParams } from "react-router-dom";
import PaginationItem from "../../components/review/Pagination.item";
import EditReviewModal from "../../components/review/EditReview.modal";
import { useAppSelector } from "../../store";
import { useQuery } from "@tanstack/react-query";
import { UserApi } from "../../api/User.api";
import useAppMutation from "../../hooks/useAppMutation";


export default function ReviewPage() {

  const [searchParams, setSearchParams] = useSearchParams();

  const {data: user} = useQuery({
    queryKey: ['user'],
    queryFn: UserApi.getMe,
  })

  const pageSize = 5
  const [page, setPage] = useState<number>(0)

  const [reviewList, setReviewList] = useState<Review[]>([])
  const [count, setCount] = useState(0)
  const [isShowEditReviewModal, setIsShowEditReviewModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState<Review | null>(null)

  const {mutate: deleteReview} = useAppMutation({
    mutationFn: ReviewApi.delete,
    onSuccess: () => {
      getReviewList()
    },
    onError: (error) => {
      if(error instanceof Error) {
        alert(error.message);
      } else {
        alert('리뷰 삭제에 실패했습니다.');
      }
    }
  })
  

  useEffect(() => {
    const _page = searchParams.get('page')
    
    let page = _page === null ? 1 : parseInt(_page)

    setPage(page)

  }, [searchParams])

  useEffect(() => {
    if(page === 0) return

    getReviewList()

  }, [page])

  const getReviewList = () => {
    if(page === undefined) return

    ReviewApi.list({page, pageSize})
    .then(result => {
      setCount(result.count)
      setReviewList(result.results)
    }).catch(console.error)
  }


  return (
    <>
      <Container>
        <div className="inner">
          <div className="ttl_area">
            <strong className="head extra">리뷰 게시판</strong>
            {(user?.isReviewBlocked === false && user?.isReviewAvailable === true) && (
              <button className="outlined_green" onClick={() => {
                setSelectedReview(null)
                setIsShowEditReviewModal(true)
              }}>리뷰 작성하기</button>
            )}
          </div>

          {reviewList.map((review, index) => (
            <ReviewItem
              key={`reivew${index}`}
              review={review}
              ellipsisHeight={49}
              onClickMore={true}
              isMyReview={!!user && review.userId === user.id}
              onEdit={() => {
                setSelectedReview(review)
                setIsShowEditReviewModal(true)
              }}
              onDelete={() => {
                if(window.confirm('리뷰를 삭제하시겠습니까?')) {
                  deleteReview(review.id)
                }
              }}
            />
          ))}
          
          <PaginationItem
            page={page ?? 1}
            count={count}
            rowsOfPage={pageSize}
            onChangePage={page => setSearchParams({page: `${page}`})}
          />
        </div>
      </Container>

      {isShowEditReviewModal && (
        <EditReviewModal
          review={selectedReview}
          onCancel={() => {
            setIsShowEditReviewModal(false)
            setSelectedReview(null)
          }}
          onSuccess={() => {
            setIsShowEditReviewModal(false)
            setSelectedReview(null)
            getReviewList();
          }}
        />
      )}
    </>
  )
}